import { ModelBase, PointT } from "pytha";
import { useEffect, useState } from "react";
import './index.less';
import { graphicStore } from "@/global/store/graphic-store";
import DeviceDetailPopWindow from "./device-pop-window";

export default function DeviceDetailPop() {

    const DeviceModelTypes = ['DvrT', 'SerialT', 'IpcT', 'AnemoclinographT', 'MonitorT', 'FluviographT']; // 特殊图元的type

    const [entities, setEntities] = useState<{ [key: string]: ModelBase }>({}); // 选中的图元
    const [entityUuids, setEntityUuids] = useState<string[]>([]); // 选中图元的uuid列表
    const [show, setShow] = useState<boolean>(false); // 是否显示气泡窗
    const [needRender, setNeedRender] = useState<boolean>(false); // 重新渲染

    // 初始化选中图元
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()?.selectControl) return;
        let selEntities = graphicStore?.extraContext?.getCurrentViewEditor()?.selectControl?.getSelectedEntities();
        setEntities(selEntities);
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])


    // 监听选中变化
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.onSelectChanged.add(generateDeviceModel);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onSelectChanged.remove(generateDeviceModel);
        }
    }, [entities])

    // 获取选中图元及其uuid
    const generateDeviceModel = () => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        let selEntities = graphicStore?.extraContext?.getCurrentViewEditor().selectControl.getSelectedEntities();
        setEntities(selEntities);
        let entityUuids = Object.keys(selEntities)?.filter(key => DeviceModelTypes.some(item => item === selEntities[key].type));
        setEntityUuids(entityUuids);
        setShow(!!!graphicStore?.extraContext?.getCurrentViewEditor().cmdControl.currentControl)
    }

    return (
        <div className="device-detail-pop-container">
            {show && entityUuids?.map(key => (
                <DeviceDetailPopWindow entity={entities[key]} key={key} needRender={needRender} setNeedReder={setNeedRender} />
            ))}
        </div>
    )
}